export interface FieldDefinition {
  /** Title to be used in forms and (by default) column headers */
  title: string;
  /** Title to be used in column headers (overrides the default title) */
  columnTitle?: string;
  /** Tooltip to be used in forms and (by default) column headers */
  tooltip?: string;
  /** Tooltip to be used in column headers (overrides the default tooltip) */
  columnTooltip?: string;
}

/**
 * Gets the form title for a field definition
 * @param field The field definition
 * @returns The form title text
 */
export const getFieldTitle = (field: FieldDefinition): string => {
  return field.title;
};

/**
 * Gets the form tooltip for a field definition
 * @param field The field definition
 * @returns The form tooltip text or undefined if not provided
 */
export const getFieldTooltip = (field: FieldDefinition): string | undefined => {
  return field.tooltip;
};

/**
 * Gets the column tooltip for a field definition
 * @param field The field definition
 * @returns The column tooltip text (falls back to form tooltip if not specified) or undefined if neither is provided
 */
export const getColumnTooltip = (field: FieldDefinition): string | undefined => {
  return field.columnTooltip || field.tooltip;
};

/**
 * Gets the column title for a field definition
 * @param field The field definition
 * @returns The column title text (falls back to form title if not specified)
 */
export const getColumnTitle = (field: FieldDefinition): string => {
  return field.columnTitle || field.title;
};
